import { AxiosResponse } from 'axios'
import { claimsApiClient } from '../httpClient'
import { AdjudicateClaimResponse } from './models/adjudication'
import { GetClaimResponse } from './models/claims'
import { RhizaRewardPayment } from './models/payment'

export async function getRequests(did: string): Promise<any> {
    return await claimsApiClient.get(`/api/v1/claims/requests?recipient=${did}&exclude_approved`)
}

export async function getNotifications(): Promise<any> {
    return await claimsApiClient.get(`/api/v1/claims/notifications`)
}

export async function getIdentities(): Promise<any> {
    return await claimsApiClient.get(`/api/v1/claims/identities`)
}

export async function postMessages(data: any): Promise<any> {
    return await claimsApiClient.post(`/api/v1/claims/messages`, data)
}

export async function getClaimsHistory(claimNumber: string): Promise<any> {
    return await claimsApiClient.get(`/api/v1/claims/${claimNumber}/history`)
}

export async function getRequestById(entryId: string): Promise<any> {
    return await claimsApiClient.get(`/api/v1/claims/requests?requested_id=${entryId}`)
}

export async function postRequests(data: any): Promise<any> {
    return await claimsApiClient.post(`/api/v1/claims/requests`, data)
}

export async function getClaimByNumber(claimNumber: string) {
    return await claimsApiClient.get<any, AxiosResponse<GetClaimResponse>>(
        `/api/v1/claims/${claimNumber}`,
    )
}

export async function getHashes(hash: string): Promise<any> {
    return await claimsApiClient.get(`/api/v1/claims/hashes/${hash}`)
}

export async function dismissNotification(id: string): Promise<any> {
    return await claimsApiClient.put(`/api/v1/claims/notifications/${id}`)
}

export async function approveRequest(id: string): Promise<any> {
    return await claimsApiClient.put(`/api/v1/claims/requests/${id}`)
}

export async function postClaim(data: any, forceSubmit = false): Promise<any> {
    return await claimsApiClient.post(`/api/v1/claims/submit?forceSubmit=${forceSubmit}`, data)
}

export async function postDentalFormClaim(data: { formPayload: any; signature: string }) {
    return await claimsApiClient.post<{ formPayload: any; signature: string }, any>(
        'api/v1/claims/submit/dental-form',
        data,
    )
}

export async function validateClaim(data: any): Promise<any> {
    return await claimsApiClient.post(`/api/v1/claims/validate`, data)
}

export async function getClaims(skip: number, limit: number, messageType: string): Promise<any> {
    return await claimsApiClient.get(
        `/api/v1/claims/?skip=${skip}&limit=${limit}&claimsType=${messageType}`,
    )
}

export async function getValidationLogs(claimNumber: string): Promise<any> {
    return await claimsApiClient.get(`/api/v1/claims/${claimNumber}/predetermination/logs`)
}

export async function adjudicateClaim(claimNumber: string, submitResults: boolean) {
    return await claimsApiClient.post<any, { data: AdjudicateClaimResponse }>(
        `/api/v1/claims/${claimNumber}/adjudicate`,
        { submitResults },
    )
}

export async function getAdjudicationResult(reportId: string) {
    const data = await claimsApiClient.get<any, AxiosResponse<AdjudicateClaimResponse>>(
        `/api/v1/claims/reports/${reportId}`,
    )
    return data
}

export async function deleteAdjudicationLogs(claimNumber: string): Promise<any> {
    return await claimsApiClient.delete(`/api/v1/claims/${claimNumber}/adjudicate`)
}

export async function getIsPayer(claimNumber: string): Promise<any> {
    return await claimsApiClient.get(`/api/v1/claims/${claimNumber}/isPayer`)
}

export async function getBlockchainPaymentByClaimNumber(claimNumber: string) {
    return await claimsApiClient.get<any, AxiosResponse<RhizaRewardPayment>>(
        `api/v1/claims/${claimNumber}/payment`,
    )
}
